export class Selection {
  container: any;
  currentSelection: any;
  startOffset: number = 0;
  currentOffset: number = 0;
  fullOffset: number = 0;

  constructor(container: any) {
    this.container = container;
  }

  getSelection() {
    if (window && window.getSelection) {
      return (window as any).getSelection().getRangeAt(0);
    } else if ((document as any).selection) {
      return (document as any).selection.createRange();
    }
  }

  sumCurrentOffset(root: any, node: any, startOffset: number) {
    for (const ele of Array.from(root.childNodes)) {
      if (node === ele) {
        break;
      }
      if ((ele as any).contains(node)) {
        const result = this.sumCurrentOffset(ele, node, 0);
        startOffset += result;
        break;
      } else {
        startOffset += (ele as any).textContent.length;
      }
    }
    return startOffset;
  }

  findNodeForPosition(container: any, currentOffset: number): any {
    let node;
    ({ node, currentOffset } = this.findNode(
      container.childNodes,
      currentOffset,
    ) as any);
    if (node.childNodes.length === 0) {
      return { node, currentOffset };
    } else {
      return this.findNodeForPosition(node, currentOffset);
    }
  }

  findNode(childNodes: NodeList, currentOffset: number) {
    for (const node of Array.from(childNodes)) {
      if (currentOffset - (node as any).textContent.length <= 0) {
        return { node, currentOffset };
      } else {
        currentOffset -= (node as any).textContent.length;
      }
    }
  }

  setCaretAtEnd(el: any) {
    if (typeof (window as any).getSelection !== 'undefined' && typeof document.createRange !== 'undefined') {
      const range = document.createRange();
      range.selectNodeContents(el);
      range.collapse(false);
      const sel: any = window.getSelection();
      if (sel) {
        sel.removeAllRanges();
        sel.addRange(range);
      }
    } else if (typeof (document.body as any).createTextRange !== 'undefined') {
      const textRange = (document.body as any).createTextRange();
      textRange.moveToElementText(el);
      textRange.collapse(false);
      textRange.select();
    }
  }

  setSelectionPosition(element: any, position: number) {
    const textNode = element.firstChild;
    const range = document.createRange();
    range.setStart(textNode, position);
    range.setEnd(textNode, position);
    const sel: any = document.getSelection();
    if (sel) {
      sel.removeAllRanges();
      sel.addRange(range);
    }
  }

  saveCurrentSelection() {
    this.currentSelection = this.getSelection();
    this.startOffset = this.currentSelection.startOffset;
    this.currentOffset = this.sumCurrentOffset(
      this.container,
      this.currentSelection.startContainer,
      this.startOffset,
    );
    this.fullOffset = this.currentOffset;
  }

  restoreSelection() {
    let node;
    if (this.currentOffset === 0) {
      return;
    }
    const range = document.createRange();
    ({ node, currentOffset: this.currentOffset } = this.findNodeForPosition(
      this.container,
      this.currentOffset,
    ));
    range.setStart(node, this.currentOffset);
    range.collapse(true);
    const sel = window.getSelection();
    if (sel) {
      sel.removeAllRanges();
      sel.addRange(range);
    }
  }
}
